import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AlertService } from '@core/services/alert.service';

@Component({
  selector: 'app-alert-container',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './alert-container.html',
  styleUrl: './alert-container.scss',
})
export class AlertContainerComponent {
  protected readonly alertService = inject(AlertService);
}
